import { render } from "./RegisterPage.vue?vue&type=template&id=1d814ec1"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"
script.render = render

export default script